import { Box } from '@mui/material';

export const Divider = () => {
  return (
    <Box sx={{ marginBottom: 3, borderTop: '1px solid', borderColor: 'neutral.light' }}>
      <Box component="hr" sx={{ border: 'none', margin: 0 }} />
    </Box>
  );
};
